import {
  IFormatSettingConfigFieldsFragment,
  Locale,
  TimeFormat,
} from '../../../../utils/apollo/graphqlSchema';
import { MaybeNil } from '../../../../utils/interfaces';
import { localeDictionary } from '../../../../utils/formatting';
import { freeze } from '@reduxjs/toolkit';
import getCurrencySymbol from '../../../../utils/formatting/getCurrencySymbol';

const TimeFormatDictionary: Record<TimeFormat, string> = freeze({
  [TimeFormat.TwelveHour]: '12-hour Clock',
  [TimeFormat.TwentyFourHour]: '24-hour Clock',
});

export const generateFormatsOptions = (
  formatConfigs: MaybeNil<IFormatSettingConfigFieldsFragment>,
  locale: Locale,
) => {
  if (!formatConfigs) {
    return null;
  }

  return {
    dateOptions: formatConfigs.dateFormats.map((format) => ({
      value: format,
      label: format,
    })),
    timeOptions: formatConfigs.timeFormats.map((format) => ({
      value: format,
      label: TimeFormatDictionary[format],
    })),
    localeOptions: formatConfigs.locales.map((locale) => ({
      value: locale,
      label: localeDictionary[locale],
    })),
    currencyOptions: formatConfigs.currencies.map((currency) => ({
      value: currency,
      label: currency + ' ' + getCurrencySymbol(currency, locale),
    })),
  };
};
